import script from "./ActionDock.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionDock.vue?vue&type=script&setup=true&lang=js"

import "./ActionDock.vue?vue&type=style&index=0&id=975f637a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-975f637a"]])

export default __exports__